import React from 'react';
import { IconPropsType } from '../../misc/types';

const Dot = (props: IconPropsType) => {
  return (
    <div className="flex items-center justify-center">
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        xmlns="http://www.w3.org/2000/svg"
        className={`w-2 h-2 ${props.additionalStyle || ''}`}
      >
        <circle cx="5" cy="5" r="5" className="fill-current" />
      </svg>
    </div>
  );
};

export default Dot;
